import { Component } from '@angular/core';
import { LovableFeedTab } from './lovable-feed-header.component';
import { LOVABLE_SAMPLE_POSTS } from './lovable-dashboard.models';

@Component({
    selector: 'app-preview-dashboard-lovable',
    templateUrl: './preview-dashboard-lovable.component.html',
    styleUrls: ['./preview-dashboard-lovable.component.css'],
})
export class PreviewDashboardLovableComponent {
    readonly samplePosts = LOVABLE_SAMPLE_POSTS;
    feedTab: LovableFeedTab = 'foryou';
}
